import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { withRuntimeContext } from 'render';
import SubBanners from '../SubBannersComponent';
import ModalCartaoPresente from "../CartaoPresente/ModalCartaoPresente";

const GLOBAL_PAGES = global.__RUNTIME__ && Object.keys(global.__RUNTIME__.pages)
const isMobile = __RUNTIME__.hints.mobile

class GiftOccasion extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isOpenGiftModal: false
		}

		this.previousSlide = this.previousSlide.bind(this);
		this.nextSlide = this.nextSlide.bind(this);
		this.onClickCta = this.onClickCta.bind(this);
	}

	static uiSchema = {
		mainBanner: {
			deskImage: {
				'ui:widget': 'image-uploader',
			},
			mobileImage: {
				'ui:widget': 'image-uploader',
			}
		},
		subBanners: {
			items: {
				image: {
					'ui:widget': 'image-uploader'
				}
			}
		}
	}

	static propTypes = {
		mainBanner: PropTypes.shape({
			deskImage: PropTypes.string,
			mobileImage: PropTypes.string
		}),
		asideText: PropTypes.string,
		buttonUrl: PropTypes.string,
		showButton: PropTypes.bool,
		showComponent: PropTypes.bool,
		bannerTitle: PropTypes.string,
		bannerText: PropTypes.string,
		ctaText: PropTypes.string,
		ctaAction: PropTypes.string,
		subBanners: PropTypes.array
	}

	static defaultProps = {
		mainBanner: {
			deskImage: "/arquivos/gift-banner-present-img.jpg",
			mobileImage: "/arquivos/gift-banner-present-mob.jpg"
		},
		seoTextColor: "#fff",
		asideText: "Departamento",
		buttonUrl: '',
		showButton: false,
		showComponent: false,
		showMainBanners: true,
		showSubBanners: true,
		ctaText: '',
		ctaAction: '',
		bannerSeoHtml: "<h1>Categoria</h1><p>Lorem ipsum molestie euismod tristique semper donec curabitur urna viverra vel sociosqu, conubia aliquet condimentum urna scelerisque sit volutpat etiam convallis. mi varius placerat nunc quam auctor purus feugiat molestie suspendisse, vitae sodales purus malesuada adipiscing tincidunt felis platea, ipsum at neque curae ut bibendum arcu ad.</p>",
		subBanners: [
			{
				image: "/arquivos/gift-present-image.jpg",
				url: '',
				params: '',
				page: '',
				externalRoute: false,
				title: "Pai",
				ctaText: 'Ver mais'
			},
			{
				image: "/arquivos/gift-present-image-2.jpg",
				url: '',
				params: '',
				page: '',
				externalRoute: false,
				title: "Amigos",
				ctaText: 'Ver mais'
			},
			{
				image: "/arquivos/gift-present-image.jpg",
				url: '',
				params: '',
				page: '',
				externalRoute: false,
				title: "Pai",
				ctaText: 'Ver mais'
			},
			{
				image: "/arquivos/gift-present-image-2.jpg",
				url: '',
				params: '',
				page: '',
				externalRoute: false,
				title: "Amigos",
				ctaText: 'Ver mais'
			}
		]
	}

	static getSchema = props => {
		const internalRouteSchema = {
			page: {
				type: 'string',
				enum: GLOBAL_PAGES,
				title: 'Página alvo do banner (interna)',
				isLayout: false
			},
			params: {
				type: 'string',
				description: 'Parâmetros separados por vírgula, e.g.: chave=valor,a=b,c=d',
				title: 'Parâmetros (interna)',
				isLayout: false
			}
		}

		const externalRouteSchema = {
			url: {
				type: 'string',
				title: 'URL (externa)',
				isLayout: false
			}
		}

		const checkCtaAction = (ctaAction) => {

			if(ctaAction == 'jump-to') {
				return {
					sectionToJump: {
						type: 'string',
						title: 'Classe/ID da Seção',
						isLayout: false
					}
				}
			}

		}

		return {
			title: 'GiftOccasion',
			description: 'Gift Occasion Slider Component',
			type: 'object',
			properties: {
				mainBanner: {
					title: 'Main Banner',
					type: 'object',
					properties: {
						deskImage: {
							type: 'string',
							title: 'Main Banner Desktop'
						},
						mobileImage: {
							type: 'string',
							title: 'Main Banner Mobile'
						}
					}
				},
				seoTextColor: {
					type: 'string',
					title: 'Banner Text Color'
				},
				asideText: {
					title: "Texto lateral",
					type: 'string'
				},
				buttonUrl: {
					type: 'string',
					title: 'Button url'
				},
				showButton: {
					type: 'boolean',
					title: 'Show sub-banners button',
					default: GiftOccasion.defaultProps.showButton
				},
				showComponent: {
					type: 'boolean',
					title: 'Show Component',
					default: GiftOccasion.defaultProps.showComponent
				},
				showMainBanners: {
					type: 'boolean',
					title: 'Show main-banners',
					default: GiftOccasion.defaultProps.showMainBanners
				},
				showSubBanners: {
					type: 'boolean',
					title: 'Show sub-banners',
					default: GiftOccasion.defaultProps.showSubBanners
				},
				bannerSeoHtml: {
					title: "Banner SEO HTML",
					type: 'string'
				},
				ctaText: {
					type: 'string',
					title: 'CTA Text',
				},
				ctaAction: {
					type: 'string',
					enum: ['', 'modal-consulta-saldo-presente', 'jump-to'],
					enumNames: [
						'None',
						'Modal Consulta Saldo Presente',
						'Pular até'
					],
					title: 'CTA Action',
				},
				...checkCtaAction(props.ctaAction),
				subBanners: {
					title: 'Sub Banners',
					type: 'array',
					minItems: 3,
					items: {
						title: 'Sub Banner',
						type: 'object',
						properties: {
							image: {
								type: 'string',
								title: 'Image Url'
							},
							title: {
								type: 'string',
								title: 'Text'
							},
							ctaText: {
								type: 'string',
								title: 'CTA text'
							},
							externalRoute: {
								type: 'boolean',
								title: 'editor.carousel.banner.externalRoute.title',
								default: false
							},
							...externalRouteSchema,
							...internalRouteSchema
						}
					}
				}
			}
		}
	}

	jumpTo(section) {
		
		if(!document.querySelector(section)) return;

		window.scrollBy({
			top: document.querySelector(section).offsetTop - 116,
			left: 0,
			behavior: 'smooth'
		});

	}

	onClickCta() {
		switch(this.props.ctaAction) {
			case 'modal-consulta-saldo-presente': 
				this.setState({ isOpenGiftModal: true });
				break;
			case 'jump-to':
				this.jumpTo(this.props.sectionToJump);
				break;
		}
	}

	previousSlide() {
		this.slider.slickPrev()
	}

	nextSlide() {
		this.slider.slickNext()
	}

	slideFallback = (banner, key) => {

		return (
			<div className="slider__slide" key={key}>
				<div className="slider__image" style={{ backgroundImage: `url("${encodeURI(banner.image)}")` }}>
					<a href={banner.page}></a>
				</div>
			</div>
		)

	}

	renderBannerCta() {

		const {ctaText, ctaAction} = this.props;

		if (ctaText && ctaAction) {
			return (
				<div className="main-banner-cta-wrapper">
					<button
						className="main-banner-cta"
						onClick={this.onClickCta}
					>
						<i className="ico-add-white" />
						{ctaText}
					</button>
				</div>
			)
		}

		return null;
	
	}

	renderSeoHtml() {
		const { bannerSeoHtml, seoTextColor, showSubBanners, ctaAction, ctaText } = this.props;
		const seoTextstyle = {
			color: seoTextColor
		}

		if (showSubBanners || isMobile) {
			return (
				<div className="presents text-wrapper">
					<div
						className="main-banner-text aaaaa"
					>
						<div 
							dangerouslySetInnerHTML={{ __html: bannerSeoHtml }}
							style={seoTextstyle}
						/>
						{this.renderBannerCta()}
					</div>
				</div>
			)
		}

		return (
			<div className="presents text-wrapper">
				<div
					className="main-banner-text"
				>
					<div 
						dangerouslySetInnerHTML={{ __html: bannerSeoHtml }}
						style={seoTextstyle}
					/>
					{this.renderBannerCta()}
				</div>
			</div>
		)

	}

	render() {

		const currentPage = this.props.runtime.page;
		
		const { 
			asideText, 
			buttonUrl, 
			showButton, 
			mainBanner, 
			subBanners,
			showMainBanners, 
			showSubBanners, 
			showComponent,
			ctaAction,
			ctaText
		} = this.props;

		let style = {};

		if (!showComponent) {
			if (
				currentPage === "store/department"
			) {
				return <div className="header-padding-container"></div>;
			}

			return null
		}

		if (!showSubBanners) {
			style = {
				marginBottom: 0
			}
		}

		let componentVariation = '';

		if (ctaText && ctaAction) {
			componentVariation = 'banner-with-action';
		}

		return (
			<div id="gift-occasion-component" className={componentVariation}>
				<section className={showMainBanners ? 'section-presents' : 'section-presents section-presents--only-text'} style={style}>

					{showMainBanners &&
						<Fragment>
							<figure
								className="section__image hidden-xs"
								style={{ backgroundImage: "url(" + encodeURI(mainBanner.deskImage) + ")" }}
							/>
							<figure
								className="section__image visible-xs-block"
								style={{ backgroundImage: "url(" + encodeURI(mainBanner.mobileImage) + ")" }}
							/>
						</Fragment>
					}

					{this.renderSeoHtml()}
					
					<SubBanners 
						showAside={true}
						asideText={asideText}
						buttonUrl={buttonUrl}
						showButton={showButton}
						banners={subBanners}
						showComponent={showSubBanners} 
					/>

				</section>
				{ctaAction === 'modal-consulta-saldo-presente' &&
					<ModalCartaoPresente
						isOpen={this.state.isOpenGiftModal}
						onClose={() => { this.setState({ isOpenGiftModal: false }) } }
					/>
				}
			</div>
		)

	}

}

export default withRuntimeContext(GiftOccasion)